"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.distriBoxNormalizer = void 0;
const mocks_json_1 = __importDefault(require("./mocks.json"));
const extractProductChannels = (children) => {
    var _a;
    const result = {};
    if (Object.keys(children).length === 0) {
        return null;
    }
    for (const key in children) {
        if (children.hasOwnProperty(key)) {
            const { categories, data } = children[key];
            const categorie = categories[0] || null;
            const icono = ((_a = data.fields) === null || _a === void 0 ? void 0 : _a.icono) || null;
            if (!result[categorie]) {
                result[categorie] = {
                    categorie,
                    imagesChannel: [],
                };
            }
            result[categorie].imagesChannel.push({
                src: icono,
                width: 143,
                height: 99,
            });
        }
    }
    return result;
};
const extractLongCharacteristicsList = (listCharacs) => {
    const result = [];
    listCharacs.map((charac) => {
        const { fields } = charac;
        const { characteristics } = fields;
        let normalizedCharacteristics = {};
        const newArrayCharacteristics = characteristics.map((item) => ({
            title: Object.assign(Object.assign({}, mocks_json_1.default["FlyOut-1"]["Text-5"]), { text: item.fields.title }),
            bullets: item.fields.description,
        }));
        normalizedCharacteristics = {
            icon: fields === null || fields === void 0 ? void 0 : fields.icon,
            title: Object.assign(Object.assign({}, mocks_json_1.default["FlyOut-1"]["Text-4"]), { text: fields === null || fields === void 0 ? void 0 : fields.title }),
            subcaracteristicas: newArrayCharacteristics,
        };
        result.push(normalizedCharacteristics);
    });
    return result;
};
const extractShortCharacteristicsList = (listCharacs) => {
    const { fields } = listCharacs;
    const { listadoCaracteristicas } = fields;
    const newArrayCharacteristics = listadoCaracteristicas.map((item) => ({
        icon: item.fields.icon,
        title: Object.assign(Object.assign({}, mocks_json_1.default["FlyOut-1"]["Text-9"]), { text: item.fields.title }),
        description: Object.assign(Object.assign({}, mocks_json_1.default["FlyOut-1"]["Text-10"]), { text: item.fields.description }),
    }));
    const result = {
        title: Object.assign(Object.assign({}, mocks_json_1.default["FlyOut-1"]["Text-8"]), { text: fields === null || fields === void 0 ? void 0 : fields.title }),
        characteristics: newArrayCharacteristics,
    };
    return result;
};
const extractProductOffer = (offer) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const res = {};
    const { data: offerData } = offer;
    res.price = offer.price || null;
    res.promoId = offer.promoId || null;
    res.bandaPromo = ((_a = offerData === null || offerData === void 0 ? void 0 : offerData.fields) === null || _a === void 0 ? void 0 : _a.bandaPromo) || null;
    res.bandaInfo = ((_b = offerData === null || offerData === void 0 ? void 0 : offerData.fields) === null || _b === void 0 ? void 0 : _b.bandaInfo) || null;
    res.claimPromo = ((_c = offerData === null || offerData === void 0 ? void 0 : offerData.fields) === null || _c === void 0 ? void 0 : _c.claimPromo) || null;
    res.titleLegal = ((_d = offerData === null || offerData === void 0 ? void 0 : offerData.fields) === null || _d === void 0 ? void 0 : _d.titleLegalcorto) || null;
    res.ctz_claimPrincipal_promo =
        ((_e = offerData === null || offerData === void 0 ? void 0 : offerData.fields) === null || _e === void 0 ? void 0 : _e.ctz_claimPrincipal_promo) || null;
    res.topDescription = ((_f = offerData === null || offerData === void 0 ? void 0 : offerData.fields) === null || _f === void 0 ? void 0 : _f.topDescription) || null;
    res.legal = ((_g = offerData === null || offerData === void 0 ? void 0 : offerData.fields) === null || _g === void 0 ? void 0 : _g.legalCorto) || null;
    res.legalCorto = offer.legal || null;
    res.upDescriptionOffer = ((_h = offerData === null || offerData === void 0 ? void 0 : offerData.fields) === null || _h === void 0 ? void 0 : _h.upDescription) || null;
    return res;
};
const isContractedProduct = (product, userCompatibilities, productCompatibilityGroup) => {
    var _a, _b, _c;
    let contractedProduct = false;
    if (userCompatibilities && productCompatibilityGroup) {
        if (productCompatibilityGroup === "fa") {
            const userProductCompatibility = userCompatibilities.fa;
            const secondaryBundle = userProductCompatibility === null || userProductCompatibility === void 0 ? void 0 : userProductCompatibility.secondaryBundle;
            const productCharacteristics = (_b = (_a = product === null || product === void 0 ? void 0 : product.productTelcoInfo) === null || _a === void 0 ? void 0 : _a.PRODUCT_CHARACTERISTIC) === null || _b === void 0 ? void 0 : _b.fields;
            if (userProductCompatibility && productCharacteristics) {
                const productTelcoCharacteristicId = productCharacteristics.telcoCharacteristicId;
                const productTelcoCharacteristicValue = productCharacteristics.telcoCharacteristicValue;
                const userSecondaryBundleCharacteristics = secondaryBundle === null || secondaryBundle === void 0 ? void 0 : secondaryBundle.characteristics;
                if (Array.isArray(userSecondaryBundleCharacteristics)) {
                    const userProductCharacteristic = (_c = userSecondaryBundleCharacteristics.find((charac) => charac.idCharacteristic === productTelcoCharacteristicId)) === null || _c === void 0 ? void 0 : _c.idValueCharacteristic;
                    const userProductIdPO = secondaryBundle.idPO;
                    if (userProductCharacteristic === productTelcoCharacteristicValue &&
                        (product === null || product === void 0 ? void 0 : product.productOffering) === userProductIdPO) {
                        contractedProduct = true;
                    }
                }
            }
        }
    }
    return contractedProduct;
};
const extractProductInfoItem = (product) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    if (!product) {
        return null;
    }
    const res = {
        name: product.name,
        alias: product.alias,
        baseOffer: {},
        offer: {},
        channels: {},
        productName: (_a = product.productTaxonomy) === null || _a === void 0 ? void 0 : _a.prodName,
        productTelcoInfo: (_d = (_c = (_b = product === null || product === void 0 ? void 0 : product.data) === null || _b === void 0 ? void 0 : _b.fields) === null || _c === void 0 ? void 0 : _c.PRODUCT_TELCO_INFO) === null || _d === void 0 ? void 0 : _d.fields,
    };
    const { data, baseOffer, offers, children } = product;
    if (baseOffer) {
        res.baseOffer = extractProductOffer(baseOffer);
    }
    if (children) {
        res.channels = extractProductChannels(children);
    }
    if (data) {
        const { fields } = data;
        let productoGPBAF = null;
        let productDetail = null;
        let cardsChars = null;
        productoGPBAF =
            (fields === null || fields === void 0 ? void 0 : fields["DATAMAP_PRODUCTO_GP_BAF"]) ||
                (fields === null || fields === void 0 ? void 0 : fields["BUSINESS_ZONA_NAME_BAF"]) ||
                (fields === null || fields === void 0 ? void 0 : fields["DATAMAP_TV"]) ||
                (fields === null || fields === void 0 ? void 0 : fields["DATAMAP_DISTRI_INTERNET"]) ||
                (fields === null || fields === void 0 ? void 0 : fields["DATAMAP_PRODUCTO"]) ||
                (fields === null || fields === void 0 ? void 0 : fields["DATAMAP_SEGUROS"]);
        cardsChars = fields === null || fields === void 0 ? void 0 : fields["CARACTERISTICAS_CARD"];
        if (fields === null || fields === void 0 ? void 0 : fields["COMPOSICION_BUNDLE"]) {
            const { fields: fieldsConectividad } = (_e = fields === null || fields === void 0 ? void 0 : fields["COMPOSICION_BUNDLE"].fields) === null || _e === void 0 ? void 0 : _e.conectividad.data;
            productoGPBAF = fieldsConectividad === null || fieldsConectividad === void 0 ? void 0 : fieldsConectividad["DATAMAP_PRODUCTO_GP_BAF"];
            productDetail = fieldsConectividad === null || fieldsConectividad === void 0 ? void 0 : fieldsConectividad["CARACTERISTICAS_FICHA"];
        }
        if (productoGPBAF) {
            const { fields } = productoGPBAF;
            res.currency = fields === null || fields === void 0 ? void 0 : fields.unidad;
            res.url2ProdCompra = fields === null || fields === void 0 ? void 0 : fields.url2ProdCompra;
            res.urlProdCompra = fields === null || fields === void 0 ? void 0 : fields.urlProdCompra;
            res.isRecom = fields === null || fields === void 0 ? void 0 : fields.isRecom;
            res.urlFicha = fields === null || fields === void 0 ? void 0 : fields.urlFicha;
            res.nombreComercial = fields === null || fields === void 0 ? void 0 : fields.nombreComercial;
            res.imageFlyOut = fields === null || fields === void 0 ? void 0 : fields.imgDeskFicha;
            res.productDespription = fields === null || fields === void 0 ? void 0 : fields.ctz_claimPrincipal;
            res.textRecommended = fields === null || fields === void 0 ? void 0 : fields.textRecommended;
            res.targetUrl = fields === null || fields === void 0 ? void 0 : fields.target;
            res.iconCard = fields === null || fields === void 0 ? void 0 : fields.iconCard;
        }
        res.productOffering = product === null || product === void 0 ? void 0 : product.productOffering;
        if (fields === null || fields === void 0 ? void 0 : fields["DATAMAP_DISTRI_INTERNET"]) {
            res.nombreComercial = (_g = (_f = fields === null || fields === void 0 ? void 0 : fields["DATAMAP_DISTRI_INTERNET"]) === null || _f === void 0 ? void 0 : _f.fields) === null || _g === void 0 ? void 0 : _g.title;
            res.moreInfoButton = (_j = (_h = fields === null || fields === void 0 ? void 0 : fields["DATAMAP_DISTRI_INTERNET"]) === null || _h === void 0 ? void 0 : _h.fields) === null || _j === void 0 ? void 0 : _j.textInfo;
            cardsChars = (_k = fields === null || fields === void 0 ? void 0 : fields["DATAMAP_DISTRI_INTERNET"]) === null || _k === void 0 ? void 0 : _k.fields;
        }
        if (cardsChars) {
            const cardCharList = ((_l = cardsChars === null || cardsChars === void 0 ? void 0 : cardsChars.fields) === null || _l === void 0 ? void 0 : _l["LISTADO_CARACTERISTICAS_CARD"]) ||
                (cardsChars === null || cardsChars === void 0 ? void 0 : cardsChars["LISTADO_CARACTERISTICAS_CARD_DISTRI_INTERNET"]);
            if (Array.isArray(cardCharList) && cardCharList[0]) {
                const characteristics = cardCharList[0];
                const paragraph = (_m = characteristics === null || characteristics === void 0 ? void 0 : characteristics.fields) === null || _m === void 0 ? void 0 : _m.characteristics;
                res.subTitle = (_o = characteristics === null || characteristics === void 0 ? void 0 : characteristics.fields) === null || _o === void 0 ? void 0 : _o.title;
                if (Array.isArray(paragraph)) {
                    res.paragraph = paragraph.join("<br/>");
                }
            }
        }
        if (productDetail) {
            const { fields } = productDetail;
            res.shortCharacteristicsList = extractShortCharacteristicsList(fields === null || fields === void 0 ? void 0 : fields["LISTADO_CARACTERISTICAS_FICHA_CORTAS"]);
            res.longCharacteristicsList = extractLongCharacteristicsList(fields === null || fields === void 0 ? void 0 : fields["LISTADO_CARACTERISTICAS_FICHA_LARGAS"]);
        }
    }
    if (offers && Object.keys(offers).length > 0) {
        Object.keys(offers).map((offer) => {
            const oferta = offers[offer];
            const ofertaRes = extractProductOffer(oferta);
            res.offer = ofertaRes;
        });
    }
    return res;
};
const extractProductInfo = (product) => {
    if (Array.isArray(product)) {
        return product.map((productItem) => extractProductInfoItem(productItem));
    }
    return extractProductInfoItem(product);
};
const normalizeOrionStructureItem = ({ product, buttonCompraLabel, topDescription, upDescription, urlLinkclient, urlLinknoclient, moreInfo, urlFichaZR, userCompatibilities, productCompatibilityGroup, }) => {
    let res = null;
    if (product) {
        res = {};
        let offerInfo = product.baseOffer;
        const channelsInfo = product.channels;
        let button = Object.assign(Object.assign({}, buttonCompraLabel), { href: product.url2ProdCompra
                ? product.url2ProdCompra
                : product.urlProdCompra || "" });
        const { isRecom } = product;
        const { textRecommended } = product;
        const { nombreComercial } = product;
        const urlFichaFromZL = urlFichaZR || "";
        const urlFicha = product.urlFicha || urlFichaFromZL;
        const productOffering = product === null || product === void 0 ? void 0 : product.productOffering;
        const moreInfoMimo = product === null || product === void 0 ? void 0 : product.moreInfoButton;
        let onClick = false;
        const subTitle = product.subTitle || "";
        const { targetUrl } = product;
        const { iconCard } = product;
        const buttonMoreInfo = Object.assign(Object.assign({}, moreInfo), { href: urlFicha });
        if (button.href.trim().length === 0) {
            let finalUrlLinknoclient = urlLinknoclient;
            let finalUrlLinkclient = urlLinkclient;
            if (process.env.NEXT_PUBLIC_WEB_VIEW === "true") {
                finalUrlLinknoclient =
                    urlLinknoclient && urlLinknoclient.indexOf("?") !== -1
                        ? `${urlLinknoclient}&utm_source=novum`
                        : `${urlLinknoclient}?utm_source=novum`;
                finalUrlLinkclient =
                    urlLinkclient && urlLinkclient.indexOf("?") !== -1
                        ? `${urlLinkclient}&utm_source=novum`
                        : `${urlLinkclient}?utm_source=novum`;
            }
            button = Object.assign(Object.assign({}, buttonCompraLabel), { href: product.url2ProdCompra
                    ? product.url2ProdCompra
                    : product.urlProdCompra || "", urlLinkclient: finalUrlLinkclient || "", urlLinknoclient: finalUrlLinknoclient || "" });
        }
        if (productOffering && moreInfoMimo) {
            buttonMoreInfo.label = moreInfoMimo;
            buttonMoreInfo.href = "";
            button.href = `https://www.movistar.es/fibra-y-movil/?productOffering=${productOffering}`;
        }
        if (!buttonMoreInfo.href) {
            onClick = true;
        }
        let currency = "";
        let quote = "";
        if (product.currency) {
            const currencySplit = product.currency.split("/");
            currency = currencySplit[0];
            quote = currencySplit[1] || "";
        }
        const price1 = { currency };
        let price2 = { price: offerInfo.price, currency, quote };
        if (product.productName) {
            res.alias = product.productName || "";
        }
        // miro si me quedo con los datos de oferta o baseoffer
        if (!!isRecom) {
            res["Label-0"] = Object.assign(Object.assign({}, mocks_json_1.default["Label-0"]), { text: isRecom });
        }
        if (!!textRecommended) {
            res["Label-0"] = Object.assign(Object.assign({}, mocks_json_1.default["Label-0"]), { text: textRecommended });
        }
        if (product.offer && Object.keys(product.offer).length > 0) {
            if ((offerInfo === null || offerInfo === void 0 ? void 0 : offerInfo.price) !== product.offer.price) {
                price1.price = offerInfo.price;
                price2 = Object.assign(Object.assign({}, price2), { price: product.offer.price, color: "red_dark" });
            }
            offerInfo = product.offer;
        }
        if (!!nombreComercial) {
            res["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), { text: nombreComercial });
        }
        if (!!subTitle) {
            res["Text-1-Sub"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1-Sub"]), { text: subTitle });
        }
        if (iconCard) {
            res["Glyph-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Glyph-1"]), { id: iconCard });
        }
        if (product.paragraph) {
            res["Text-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-2"]), { text: product.paragraph });
        }
        if (upDescription && upDescription.text) {
            res["Text-3"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-3"]), upDescription);
        }
        if (offerInfo.claimPromo) {
            res["Text-3"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-3"]), { text: offerInfo.claimPromo, color: "red_dark" });
        }
        if (offerInfo.ctz_claimPrincipal_promo) {
            res["Text-3"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-3"]), { text: offerInfo.ctz_claimPrincipal_promo, color: "grey5" });
        }
        if (offerInfo === null || offerInfo === void 0 ? void 0 : offerInfo.upDescriptionOffer) {
            res["Text-3"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-3"]), { text: offerInfo.upDescriptionOffer });
        }
        if (topDescription && topDescription.text) {
            res["Text-4"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-4"]), topDescription);
        }
        if (offerInfo.topDescription && offerInfo.topDescription) {
            res["Text-4"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-4"]), { text: offerInfo.topDescription, color: "grey6" });
        }
        if (offerInfo.bandaInfo) {
            res["Text-4"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-4"]), { text: offerInfo.bandaInfo, color: "red_dark" });
        }
        if (offerInfo.bandaPromo) {
            res["Label-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Label-1"]), { label: offerInfo.bandaPromo });
        }
        // Personalizacion de la card con compatibilidades del cliente
        // Se intenta hacer match entre id y valor de la caracteristica y las del secondary bundle del userCompatibilities del secure
        const contractedProduct = isContractedProduct(product, userCompatibilities, productCompatibilityGroup);
        if (contractedProduct) {
            res["Label-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Label-2"]), { label: "Contratado" });
        }
        if (price1 && price1.price) {
            res["Price-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Price-1"]), price1);
        }
        if (price2 && (price2.price || price2.currency)) {
            res["Price-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Price-2"]), price2);
        }
        if (!contractedProduct &&
            button &&
            (button.href || button.urlLinkclient || button.urlLinknoclient)) {
            let finalhref = button.href;
            if (process.env.NEXT_PUBLIC_WEB_VIEW === "true") {
                finalhref =
                    button.href.trim().length > 0
                        ? button.href.indexOf("?") !== -1
                            ? `${button.href}&utm_source=novum`
                            : `${button.href}?utm_source=novum`
                        : "";
            }
            res["Button-1"] = Object.assign(Object.assign(Object.assign({}, mocks_json_1.default["Button-1"]), button), { href: finalhref });
        }
        if (offerInfo.titleLegal) {
            res["Button-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Button-2"]), { label: offerInfo.titleLegal });
        }
        if ((buttonMoreInfo && buttonMoreInfo.href) || productOffering) {
            if (!contractedProduct) {
                res["Button-3"] = Object.assign(Object.assign({}, mocks_json_1.default["Button-3"]), buttonMoreInfo);
            }
            res["CustomLink-1"] = Object.assign(Object.assign({}, mocks_json_1.default["CustomLink-1"]), { href: buttonMoreInfo.href, title: nombreComercial || "" });
            if (!!targetUrl) {
                res["CustomLink-1"].target = targetUrl;
                res["Button-3"].target = targetUrl;
            }
        }
        if (offerInfo.titleLegal && offerInfo.legal) {
            res["Legal-1"] = {
                "Text-1": Object.assign(Object.assign({}, mocks_json_1.default["Legal-1"]["Text-1"]), { text: offerInfo.titleLegal }),
                "Text-2": Object.assign(Object.assign({}, mocks_json_1.default["Legal-1"]["Text-2"]), { text: offerInfo.legal }),
            };
        }
        if (onClick) {
            res["FlyOut-1"] = {
                "Text-1": Object.assign(Object.assign({}, mocks_json_1.default["FlyOut-1"]["Text-1"]), { text: "" }),
                "Text-2": Object.assign(Object.assign({}, mocks_json_1.default["FlyOut-1"]["Text-2"]), { text: nombreComercial }),
                "Text-3": Object.assign(Object.assign({}, mocks_json_1.default["FlyOut-1"]["Text-3"]), { text: product === null || product === void 0 ? void 0 : product.productDespription }),
                "Image-1": Object.assign(Object.assign({}, mocks_json_1.default["FlyOut-1"]["Image-1"]), { src: product === null || product === void 0 ? void 0 : product.imageFlyOut }),
                "Price-1": Object.assign(Object.assign({}, mocks_json_1.default["FlyOut-1"]["Price-1"]), price1),
                "Price-2": Object.assign(Object.assign({}, mocks_json_1.default["FlyOut-1"]["Price-2"]), price2),
                "Features-1": (product === null || product === void 0 ? void 0 : product.longCharacteristicsList) || {},
                "Features-2": (product === null || product === void 0 ? void 0 : product.shortCharacteristicsList) || {},
                "TextLegal-1": Object.assign({}, mocks_json_1.default["FlyOut-1"]["Text-11"]),
                "TextLegal-2": Object.assign({}, mocks_json_1.default["FlyOut-1"]["Text-12"]),
                "TextLegal-3": Object.assign(Object.assign({}, mocks_json_1.default["FlyOut-1"]["Text-13"]), { text: offerInfo.legalCorto }),
            };
        }
        if (channelsInfo) {
            res["Channels-1"] = { channelsInfo };
        }
    }
    return res;
};
const normalizeOrionStructure = ({ products, buttonCompraLabel, topDescription, upDescription, urlLinkclient, urlLinknoclient, moreInfo, urlFichaZR, productCompatibilityGroup, userCompatibilities, }) => {
    if (Array.isArray(products)) {
        const productsObj = {};
        products.forEach((product, i) => (productsObj[`Product-${i + 1}`] = normalizeOrionStructureItem({
            product,
            buttonCompraLabel,
            topDescription,
            upDescription,
            urlLinkclient,
            urlLinknoclient,
            moreInfo,
            urlFichaZR: urlFichaZR && (urlFichaZR === null || urlFichaZR === void 0 ? void 0 : urlFichaZR[i]),
            productCompatibilityGroup,
            userCompatibilities,
        })));
        return productsObj;
    }
    return {
        "Product-1": normalizeOrionStructureItem({
            product: products,
            buttonCompraLabel,
            topDescription,
            upDescription,
            urlLinkclient,
            urlLinknoclient,
            moreInfo,
            productCompatibilityGroup,
            userCompatibilities,
        }),
    };
};
/**
 * normalizador del modulo MODULO_BUYBOX
 * @param {object} fields
 * @returns
 */
const distriBoxNormalizer = (data, userCompatibilities, productCompatibilityGroup) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    try {
        const res = {};
        const buttonCompraLabel = { label: (_a = data === null || data === void 0 ? void 0 : data.fields) === null || _a === void 0 ? void 0 : _a.textButton };
        const topDescription = { text: (_b = data === null || data === void 0 ? void 0 : data.fields) === null || _b === void 0 ? void 0 : _b.topDescription };
        const upDescription = { text: (_c = data === null || data === void 0 ? void 0 : data.fields) === null || _c === void 0 ? void 0 : _c.upDescription };
        const urlLinkclient = (_d = data === null || data === void 0 ? void 0 : data.fields) === null || _d === void 0 ? void 0 : _d.urlLinkclient;
        const urlLinknoclient = (_e = data === null || data === void 0 ? void 0 : data.fields) === null || _e === void 0 ? void 0 : _e.urlLinknoclient;
        const moreInfo = { label: (_f = data === null || data === void 0 ? void 0 : data.fields) === null || _f === void 0 ? void 0 : _f.textInfo };
        const viewType = ((_g = data === null || data === void 0 ? void 0 : data.fields) === null || _g === void 0 ? void 0 : _g.viewType) || "";
        const products = extractProductInfo((_h = data === null || data === void 0 ? void 0 : data.fields) === null || _h === void 0 ? void 0 : _h.products);
        const productZL = extractProductInfo((_j = data === null || data === void 0 ? void 0 : data.fields) === null || _j === void 0 ? void 0 : _j.productZL);
        let productZR = extractProductInfo((_k = data === null || data === void 0 ? void 0 : data.fields) === null || _k === void 0 ? void 0 : _k.productZR);
        if (!productZR) {
            productZR = productZL;
        }
        const urlFichaZR = productZL &&
            productZL.map((element) => {
                return element.urlFicha;
            });
        const mimovistarZL = extractProductInfo(data === null || data === void 0 ? void 0 : data.fields.mimovistarZL);
        const mimovistarZR = extractProductInfo(data === null || data === void 0 ? void 0 : data.fields.mimovistarZR);
        if (productZL) {
            res["Product-ZL"] = normalizeOrionStructure({
                products: productZL,
                buttonCompraLabel,
                topDescription,
                upDescription,
                urlLinkclient,
                urlLinknoclient,
                moreInfo,
                productCompatibilityGroup,
                userCompatibilities,
            });
        }
        if (productZR) {
            res["Product-ZR"] = normalizeOrionStructure({
                products: productZR,
                buttonCompraLabel,
                topDescription,
                upDescription,
                urlLinkclient,
                urlLinknoclient,
                moreInfo,
                urlFichaZR,
                productCompatibilityGroup,
                userCompatibilities,
            });
        }
        if (mimovistarZL) {
            res["mimovistar-ZL"] = normalizeOrionStructure({
                products: mimovistarZL,
                buttonCompraLabel,
                topDescription,
                moreInfo,
                productCompatibilityGroup,
                userCompatibilities,
            });
        }
        if (mimovistarZR) {
            res["mimovistar-ZR"] = normalizeOrionStructure({
                products: mimovistarZR,
                buttonCompraLabel,
                topDescription,
                moreInfo,
                productCompatibilityGroup,
                userCompatibilities,
            });
        }
        if (products) {
            // Ordena los productos por precio, poniendo el producto que tiene contratado el primero, si es que lo hay
            const orderedProductsByPrice = products.sort((product1, product2) => {
                if (isContractedProduct(product1, userCompatibilities, productCompatibilityGroup)) {
                    return -1; // product1 va primero
                }
                if (isContractedProduct(product2, userCompatibilities, productCompatibilityGroup)) {
                    return 1; // product2 va primero
                }
                return product1.baseOffer.price - product2.baseOffer.price;
            });
            res["List-0"] = normalizeOrionStructure({
                products: orderedProductsByPrice,
                buttonCompraLabel,
                topDescription,
                upDescription,
                urlLinkclient,
                urlLinknoclient,
                moreInfo,
                urlFichaZR,
                productCompatibilityGroup,
                userCompatibilities,
            });
        }
        res["Name"] = "DISTRI_BOX";
        res.viewType = viewType;
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.distriBoxNormalizer = distriBoxNormalizer;
exports.default = exports.distriBoxNormalizer;
//# sourceMappingURL=index.js.map